// extracted by mini-css-extract-plugin
export default {"container":"ZO-z","title":"_O-z","link":"aP-z"};